import { useIntl } from "react-intl";
import React from "react";
import CishContainer from "./cish.container";

function CishContainerIntl() {
    const intl = useIntl()
    return (
        <CishContainer intl={intl}></CishContainer>
    );
  }

  export default CishContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/cish/cish.intl.js